import createApp from './app.js'

import authService from './service.auth.js'
import firestoreService from './service.firestore.js'
import functionsService from './service.functions.js'

const appConfig = {"apiKey":undefined,"authDomain":"staging-controlpad-cloud.firebaseapp.com","databaseURL":"https:\u002F\u002Fstaging-controlpad-cloud.firebaseio.com","projectId":"staging-controlpad-cloud","storageBucket":"staging-controlpad-cloud.appspot.com","messagingSenderId":"787300454715","appId":"1:787300454715:web:c4353c4e857a2d9fb5271e"}

export default async (ctx, inject) => {
  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.server) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
    firestoreService(session, firebase, ctx, inject),
    functionsService(session, firebase, ctx, inject),

    ]
  }

  if (process.client) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
      firestoreService(session, firebase, ctx, inject),
      functionsService(session, firebase, ctx, inject),

    ]
  }

  const [
    auth,
    firestore,
    functions
  ] = await Promise.all(servicePromises)

  const fire = {
    auth: auth,
    firestore: firestore,
    functions: functions
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}

function forceInject (ctx, inject, key, value) {
  inject(key, value)
  const injectKey = '$' + key
  ctx[injectKey] = value
  if (typeof window !== "undefined" && window.$nuxt) {
  // If clause makes sure it's only run when ready() is called in a component, not in a plugin.
    window.$nuxt.$options[injectKey] = value
  }
}